import { useState, useEffect } from 'react';

// Global search state (shared across components)
let globalKeyword = '';
let searchListeners: Set<(keyword: string) => void> = new Set();

const notifySearchChange = (keyword: string) => {
    globalKeyword = keyword;
    searchListeners.forEach(listener => listener(keyword));
};

export const useCodePipelinesSearch = () => {
    const [keyword, setKeyword] = useState(globalKeyword);

    useEffect(() => {
        const listener = (newKeyword: string) => {
            setKeyword(newKeyword);
        };
        searchListeners.add(listener);
        return () => {
            searchListeners.delete(listener);
        };
    }, []);

    const handleFilterByKeyword = (newKeyword: string) => {
        notifySearchChange(newKeyword);
    };

    return {
        keyword,
        handleFilterByKeyword,
    };
};
